/**
 * Ventanita de avance al ejecutar confronta / exportar reportes (estilo descarga SAT).
 * Solo barra e información de progreso (sin botón Continuar).
 */
import { createPortal } from "react-dom";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function ConfrontaRunProgress({
  progress,
  testId = "confronta-run-progress",
  stepLabel: stepLabelProp,
}) {
  if (!progress || typeof document === "undefined") return null;

  const percent = Math.min(100, Math.max(0, Number(progress.percent) || 0));
  const total = Number(progress.total) || 0;
  const current = Number(progress.current) || 0;
  const done = percent >= 100;
  const stepLabel = stepLabelProp || (done ? "DONE" : (progress.stepLabel || "CONFRONTA"));
  const message = progress.message || (done ? "Confronta completada" : "Ejecutando confronta…");
  const detail =
    progress.detail ||
    (total > 1 && current > 0
      ? `Mes ${current} de ${total} · puede tardar varios minutos con muchos CFDI.`
      : total > 1
        ? `Periodo de ${total} meses · puede tardar varios minutos con muchos CFDI.`
        : "Puede tardar varios minutos con muchos CFDI.");

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/45 p-4"
      data-testid={`${testId}-overlay`}
      role="presentation"
    >
      <div
        className="w-full max-w-md text-left rounded-md border border-blue-200 bg-white p-3 space-y-2 shadow-2xl"
        data-testid={testId}
        role="status"
        aria-live="assertive"
        aria-busy={!done}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 text-[10px] text-slate-600">
          {done ? (
            <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-emerald-600" aria-hidden />
          ) : (
            <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" aria-hidden />
          )}
          <span className="font-semibold uppercase">{stepLabel}</span>
          <span className="ml-auto tabular-nums">{percent}%</span>
        </div>
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
          <div
            className="h-full bg-blue-600 transition-all duration-500"
            style={{ width: `${percent}%` }}
          />
        </div>
        <p className="text-[10px] m-0 text-slate-600">{message}</p>
        <p className="text-[10px] m-0 text-slate-500">{detail}</p>
      </div>
    </div>,
    document.body,
  );
}
